var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.doFunction}},[_vm._v(_vm._s(_vm.content))])
}
var staticRenderFns = []

export { render, staticRenderFns }